import React from "react";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

import { fetchSearchResultsByKeyword } from "@safecv/actions/postActions";
import {
  POSSIBLE_EVIDENCE_OPEN,
  POSSIBLE_EVIDENCE_CLOSE,
} from "@safecv/actions/types";

const CodebookMenu = (props) => {
  const { jobId, keywords, setSelectedSearchResult } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const dispatch = useDispatch();
  const searchPayload = useSelector(
    (state) => state.verification.searchResults,
    shallowEqual
  );
  const search = (keyword) => {
    dispatch(fetchSearchResultsByKeyword(jobId, keyword));
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    search(JSON.parse(keywords).join(","));
    dispatch({
      type: POSSIBLE_EVIDENCE_OPEN,
    });
  };

  const handleClose = () => {
    setAnchorEl(null);
    dispatch({
      type: POSSIBLE_EVIDENCE_CLOSE,
    });
  };

  return (
    <>
      <div className="input-evidences" onClick={handleClick}>
        Possible Evidences
      </div>
      {searchPayload && (
        <Menu
          id="menu"
          keepMounted
          anchorEl={anchorEl}
          onClose={handleClose}
          open={Boolean(anchorEl)}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          PaperProps={{
            style: {
              borderRadius: "5px",
              width: "20%",
            },
          }}
        >
          {searchPayload.map((item, i) => {
            return (
              <MenuItem
                key={i}
                onClick={() => setSelectedSearchResult(item.id)}
                className="input-search-result"
              >
                {item.annotationSpecificMessage}
              </MenuItem>
            );
          })}
          {searchPayload.length === 0 && (
            <span className="input-search-no-result"> No results found </span>
          )}
        </Menu>
      )}
    </>
  );
};

export default CodebookMenu;
